import React, { FC } from "react";
import { Routes } from "@Libs/Router/Components/Routes/Routes";
import { Route } from "@Libs/Router/Components/Route/Route";
import { Navigate } from "@Libs/Router/Components/Navigate/Navigate";
import { Match, On, Other } from "@Libs/Utils/Components/Match/Match";
import { useServiceProviderMetrics } from "@modules/ServiceProviders/hooks/useServiceProviderMetrics";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";
import { SuperTalent } from "@modules/ServiceProviders/Components/SuperTalent";
import { SuperTalentMetrics } from "@modules/ServiceProviders/Components/SuperTalentMetrics";
import { IAppRoute } from "@App/types";
import { RepeatRate } from "@modules/ServiceProviders/Components/RepeatRate";
import { RealisationRate } from "@modules/ServiceProviders/Components/RealisationRate";
import { SelectionRate } from "@modules/ServiceProviders/Components/SelectionRate";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { IErrorResponse } from "@api";
import { useFeatureFlag } from "@Libs/FeatureFlags/hooks/useFeatureFlag";

export const SERVICE_PROVIDER_METRICS_BASE_ROUTE: IAppRoute[] = [
  "SUPERTALENT_OBJECTIVES",
];

export const ServiceProviderMetricsRouter: FC = () => {
  const { currentUser } = useCurrentUser({
    includes: ["serviceProvider"],
  });

  const { isLoading, error } = useServiceProviderMetrics(
    currentUser?.serviceProvider?.id
  );

  const {
    isEnabled: isAdditionalSuperTalentMetricsEnabled,
    isLoading: isFlagLoading,
  } = useFeatureFlag("additional_supertalent_metrics");

  if (isLoading || isFlagLoading) {
    return <LoadingScreen />;
  }

  return (
    <Match value={(error as IErrorResponse)?.response?.status}>
      <On valueBetween={[400, 499]}>
        <Navigate to="NOT_FOUND" reload />
      </On>

      <On valueBetween={[500, 599]}>
        <Navigate to="SERVER_ERROR" reload />
      </On>

      <Other>
        <Routes>
          <Route fragments="REPEAT_RATE" matchAny element={<RepeatRate />} />
          <Route fragments="REALISATION_RATE" matchAny element={<RealisationRate />} />
          <Route fragments="SELECTION_RATE" matchAny element={<SelectionRate />} />
          <Route
            fragments="ROOT"
            matchAny
            element={
              isAdditionalSuperTalentMetricsEnabled ? (
                <SuperTalentMetrics />
              ) : (
                <SuperTalent />
              )
            }
          />
        </Routes>
      </Other>
    </Match>
  );
};
